import {defineStore} from 'pinia';
import {useThemeStore} from "@js/store/ThemeStore.js";

export const useMenuStore = defineStore('menuStore', {
    state: () => ({
        isSidenavOpen: false,
        isProfileSidenavOpen: false,
        isMenuCatalogOpen: false,
        menuItems: null,
        activeCatalog: 'plitka',
        showCatalogPing: false,
        pingColor: 'bg-red-600',
    }),
    actions: {
        triggerCatalogButtonPing(pingColor) {
            this.pingColor = pingColor
            this.showCatalogPing = true;
            setTimeout(() => {
                this.showCatalogPing = false;
            }, 800);
        },
        toggleMenuCatalog() {
            this.isMenuCatalogOpen = !this.isMenuCatalogOpen
        },
        changeActiveCatalogMenu(activeMenu) {
            this.activeCatalog = activeMenu
        },
        toggleSidenav() {
            this.isSidenavOpen = !this.isSidenavOpen
            this.setBodyOverflow()
        },
        toggleProfileSidenav() {
            this.isProfileSidenavOpen = !this.isProfileSidenavOpen
            this.setBodyOverflow()
        },
        closeSidenav() {
            if (this.isSidenavOpen) {
                this.isSidenavOpen = false
                this.setBodyOverflow()
            }
        },
        closeProfileSidenav() {
            if (this.isProfileSidenavOpen) {
                this.isProfileSidenavOpen = false
                this.setBodyOverflow()
            }
        },
        setBodyOverflow() {
            const themeStore = useThemeStore()
            themeStore.setBodyOverflow(this.isSidenavOpen || this.isMenuCatalogOpen || this.isProfileSidenavOpen)
        },
    }
});
